import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import BigNumber from 'bignumber.js';

// @material-ui
import { Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';

// core
import { getMoneyAccountBalance } from '_core/utils/api';
import { withVisitorInfo } from '_core/utils/visitorInfo';
import { useGlobal } from '_core/hooks/useGlobal';
import { withLang } from '_core/hocs/withLang';
import { Price } from '_core/components/Price';
import { State } from '_core/components/State';

// style
import { useBlockedMoneyNoticeStyle } from './blockedMoneyNoticeStyle';


const RawBlockedMoneyNotice = (props) => {
  const { className, visitorInfo, langInfo, getLangString: l } = props;

  const {
    config: { API_NOTICE },
  } = useGlobal();

  const classes = useBlockedMoneyNoticeStyle();
  const [nodeKey, setNodeKey] = React.useState(0);

  React.useEffect(() => {
    const notifyListener = (event) => event.detail.name === API_NOTICE.VISITOR_BALANCE && setNodeKey(nk => nk + 1);
    
    window.addEventListener('notify', notifyListener);
    
    return () => window.removeEventListener('notify', notifyListener);
  }, []);

  React.useEffect(() => {
    setNodeKey(nk => nk + 1)
  }, [langInfo]);

  const rootClasses = clsx({
    [classes.root]: true,
    [className]: className != null,
  });

  const getAccounts = (balance) =>
    Object.values(balance).reduce((result, account) => {
      if (!BigNumber(account.blocked.value || '0').isZero() && visitorInfo.inGroup(account.visitor_group))
        result.push(account);
      
      return result;
    }, []);

  const renderItems = (accounts) =>
    accounts.map((item) => (
      <div key={item.id}>
        <Typography
          variant="body2"
          display="inline"
          className={classes.account}
        >
          {item.title}:
        </Typography>

        <Typography variant="body2" display="inline">
          <Price
            value={item.blocked.value}
            currency={item.blocked.currency.id}
            className={classes.amount}
          />
        </Typography>
      </div>
    ));

  return (
    <State
      key={nodeKey}
      getProps={{
        balance: () => getMoneyAccountBalance(visitorInfo.info?.id)
      }}
      render={({ balance }) => {
        const accounts = getAccounts(balance)

        if (accounts.length === 0) {
          return null
        }

        return (
          <Alert severity="info" className={rootClasses}>
            <AlertTitle>
              <Typography
                variant="body1"
                gutterBottom={true}
                className={classes.title}
              >
                {l('r.zarezervirovannye.sredstva')}
              </Typography>
            </AlertTitle>

            {renderItems(accounts)}
          </Alert>
        )
      }}
    />
  );
};

RawBlockedMoneyNotice.displayName = 'RawBlockedMoneyNotice';

RawBlockedMoneyNotice.defaultProps = {};

RawBlockedMoneyNotice.propTypes = {
  // self props
  className: PropTypes.string,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
  
  // withVisitorInfo
  visitorInfo: PropTypes.object.isRequired
};

export const BlockedMoneyNotice = withVisitorInfo(withLang(RawBlockedMoneyNotice));
